export default {
  host: `https://mission-control-api.esper.cloud/api/06-2020/signup-apis/`,
};
